import * as React from "react";
import type { SVGProps } from "react";
const SvgLabelUpgradeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="label_upgrade_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="m536.661 94.976 392.534 395.093a33.024 33.024 0 0 1 6.954 35.755 32.768 32.768 0 0 1-30.25 20.224H728.747v196.053a65.707 65.707 0 0 1-65.622 65.622H363.904A65.707 65.707 0 0 1 298.24 742.1V546.133H118.23a32.853 32.853 0 0 1-23.297-56.064L490.155 94.976a32.768 32.768 0 0 1 46.506 0zM298.667 853.333a42.667 42.667 0 1 0 0 85.334h426.666a42.667 42.667 0 1 0 0-85.334H298.667z"
    />
  </svg>
);
export default SvgLabelUpgradeIcon;
